export const isValidRole = (SUB_TYPE) => {
    const userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : {};
    const availableRoles = Object.keys(userDetails).length > 0 ? userDetails.availableRoles : [];
    const availablePermissions = Object.keys(userDetails).length > 0 ? userDetails.permissions : [];

    if((availableRoles && availableRoles.includes('ROLE_SUPER_ADMIN')) || (availablePermissions && availablePermissions.find(o => o.permissionCode === SUB_TYPE))){
        return true;
    }
    return false;
}

export const UpdateObject = (oldObject, updatedValue) => {
    return {
        ...oldObject,
        ...updatedValue,
    }
}

export const ScrollToTop = () => {
    window.scrollTo({
        // top: document.body.scrollHeight,
        top: 0,
        behavior: 'smooth'
    });
}

export const setChainIdLS = (chainId)=>{
    localStorage.setItem("chainIdLS", chainId);
}

export const getChainIdLS = ()=>{
   const chainId = localStorage.getItem("chainIdLS");
   return chainId
}